export const initPropostaItems = [{
  title: 'nuovaProposta',
  image: '/images/generic/proposta.svg',
  to: '/nuovaProposta',
/*}, {
  title: 'questionario',
  image: '/images/generic/stepper/questionari.svg',
  to: '/nuovoQuestionario',*/
}];